import { createStore, compose, applyMiddleware } from 'redux';
import rootReducer from '../reducers/index';
import { thunk } from 'redux-thunk';

export default function configureStore() {
	const middleware = [];

	middleware.push(thunk);

	const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

	return createStore(
		rootReducer,
		composeEnhancer(applyMiddleware(...middleware))
	);
}
